import { Store } from "pullstate";
import { OrganizationAttributeType } from "services/KnowfullyAdminClient";

export type AttributeStore = {
  organizationAttributeType: OrganizationAttributeType | undefined;
};

const attributeStore = new Store<AttributeStore>({
  organizationAttributeType: undefined,
});

export default attributeStore;
